import {
  AUTH_ERROR,
  AUTH_FAILURE,
  AUTH_REQUEST,
  AUTH_SIGNUP,
  AUTH_SUCCESS,
  USER_SIGNOUT,
} from './actionTypes';
import { AUTHENTICATED, ERROR, IDLE, LOADING, NOT_AUTHENTICATED } from './constants/authStatuses';

export default function authReducer(state = IDLE, action) {
  switch (action.type) {
    case AUTH_REQUEST:
      return LOADING;
    case AUTH_SUCCESS:
    case AUTH_SIGNUP:
      return AUTHENTICATED;
    case AUTH_FAILURE:
    case USER_SIGNOUT:
      return NOT_AUTHENTICATED;
    case AUTH_ERROR:
      return ERROR;
    default:
      return state;
  }
}
